import { Component } from "react";
import { DirtyPageContext, IDirtyPageContext } from "./DirtyPageContext";

export interface IDirtyPageObserverProps
{
    pageKey: string;
    isDirty: boolean;
}

export class DirtyPageObserver extends Component<IDirtyPageObserverProps>
{
    public static contextType = DirtyPageContext;
    declare public context: IDirtyPageContext | undefined;

    public componentDidMount(): void
    {
        this.dirtyPageContext.setPageDirty(this.props.pageKey, this.props.isDirty);
    }

    public componentDidUpdate(prevProps: IDirtyPageObserverProps): void
    {
        const { pageKey, isDirty } = this.props;

        if (prevProps.pageKey !== pageKey)
        {
            this.dirtyPageContext.setPageDirty(prevProps.pageKey, false);
            this.dirtyPageContext.setPageDirty(pageKey, isDirty);
            return;
        }

        if (prevProps.isDirty !== isDirty)
        {
            this.dirtyPageContext.setPageDirty(pageKey, isDirty);
        }
    }

    public componentWillUnmount(): void
    {
        this.dirtyPageContext.setPageDirty(this.props.pageKey, false);
    }

    public render(): null
    {
        return null;
    }

    private get dirtyPageContext(): IDirtyPageContext
    {
        if (!this.context)
        {
            throw new Error(
                "DirtyPageContext is not available. Wrap your app with DirtyPageProvider.",
            );
        }

        return this.context;
    }
}

export default DirtyPageObserver;
